import { showAlert } from "helper";
import { Box } from "@mui/material";
import Button from '../../../Button';
import styled from "styled-components";
import FormField from "components/FormField";
import React, { useState, useEffect } from "react";
import { updateUser } from "services/post/updateUser";
import { fetchProfile } from "actions/profileActions";
import { useSelector, useDispatch } from "react-redux";
import BlackSelect from "components/common/BlackSelect";
import TooltipIconButton from "components/TooltipIconButton";
import { DeleteOutline, LockOutlined } from "@mui/icons-material";
import { deleteGuestsUsersApi } from "services/post/deleteGuestsUsersApi";
import { addUsersGuestToTeamApi } from "services/get/addUsersGuestToTeamApi";

const UserTabs = styled.div``;

const TeamSelector = styled.div`
  height: calc(100% - 4px);
  width: 100px;
  padding-bottom: 10px;
  margin-left: 10px;

  .MuiFormControl-root {
    width: 100%;
    height: 100%;
    background-color: #232323 !important;

    .MuiSelect-root {
      color: #c4c4c4;
      .MuiSelect-select {
        padding: 4px;
      }
    }
  }
`;

const UsersList = styled.div`
  h2 {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 13px;
  }

  .header-box {
    border-top: 1px solid #a0a0a0;
    border-bottom: 1px solid #a0a0a0;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    color: #c4c4c4;

    .name {
      width: 30%;
    }

    .status {
      width: 15%;
      text-align: center;
    }

    .team {
      width: 20%;
      text-align: center;
    }

    .role {
      width: 20%;
      text-align: center;
    }

    .actions {
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        font-size: 1.4rem !important;
      }
    }
  }

  .user-item {
    border-bottom: 1px solid #a0a0a0;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    color: #c4c4c4;
    width: 100%;
    display: inline-flex;
    justify-content: space-between;

    .name {
      width: 30%;
    }

    .status {
      width: 15%;
      text-align: center;
      color: #707173;

      &.active {
        color: #15c67d;
      }
    }

    .team {
      width: 30%;
      height: 20px;
      text-align: left;

      .MuiSelect-selectMenu {
        font-size: 9px;
      }

      .MuiSelect-icon {
        font-size: 1rem;
        top: calc(50% - 5px);
      }

      .MuiFormControl-root {
        width: 100%;
        height: 100%;
        background-color: #232323 !important;

        .MuiSelect-root {
          color: #c4c4c4;
          .MuiSelect-select {
            padding: 4px;
          }
        }
      }
    }

    .role {
      width: 20%;
      text-align: center;
    }

    .actions {
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const LockedHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 13px;

  h2 {
    margin: 0;
  }

  button {
    margin-left: 5px;
  }

  svg {
    font-size: 18px !important;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  height: 60px;
`

const isEmail = RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);

const UsersContent = (props) => {
  const [users, setUsers] = useState();
  const [isLocked, setIsLocked] = useState(false);
  const [teams, setTeams] = useState(props.teams);
  const [roles, setRoles] = useState(props.roles);
  const [newUser, setNewUser] = useState({
    email: "",
    status: "Pending",
    team: teams[0]?.id,
    role: roles[0]?.id,
  });
  const [selectedUserIDs, setSelectedUserIDs] = useState([]);
  const profile = useSelector(state => state.profile.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    setUsers(props.data);
  }, [props.data])

  useEffect(() => {
    setTeams(props.teams);
  }, [props.teams])

  useEffect(() => {
    if (roles && roles[0]) {
      setNewUser({ ...newUser, role: roles[0].id })
    }
  }, [roles])

  const handleChangeNewUserEmail = (e) => {
    setNewUser({ ...newUser, email: e.target.value });
  };

  const handleChangeNewUserRole = (val) => {
    setNewUser({ ...newUser, role: val })
  }

  const addUser = async () => {
    if (!profile.organizations) return
    const org_id = profile.organizations[0].id;

    if (!isEmail.test(newUser.email)) {
      showAlert('error', 'Please enter a valid email address.');
      return;
    }

    const response = await addUsersGuestToTeamApi(org_id, newUser.email, newUser.role);
    if (response && response.status === 201) {
      showAlert('success', 'Invitation has been successfully sent!');
    }
  };

  const deleteUsers = async () => {
    if (selectedUserIDs.length === 0) {
      showAlert('error', 'Please select users to delete.');
    } else {
      if (!profile.organizations) return;

      const org_id = profile.organizations[0].id;
      const response = await deleteGuestsUsersApi(selectedUserIDs, org_id);
      if (response && response.status === 200) {
        const usersNew = users.filter(
          ({ user_id }) => !selectedUserIDs.includes(user_id)
        );

        setUsers(usersNew);
        setSelectedUserIDs([]);
        fetchProfile(dispatch);
        showAlert('success', 'Selected users have been successfully deleted!');
      }
    }
  };

  const handleChangeUser = (id) => {
    if (selectedUserIDs.includes(id)) {
      setSelectedUserIDs(selectedUserIDs.filter((uid) => uid !== id));
    } else {
      setSelectedUserIDs([...selectedUserIDs, id]);
    }
  };

  const handleChangeUserTeam = async (value, user, index) => {
    const updatedTeam = {...user, team: value };
    const data = { user_id: user.user_id, team: updatedTeam.team };
    const response = await updateUser(user.org_user, data);
    if (response && response.status === 200) {
      let usersCopy = users;
      usersCopy[index] = {...user, team: response.data };
      setUsers([...usersCopy]);
      fetchProfile(dispatch);
      showAlert('success', 'User team have been successfully updated!');
    }
  };

  return (
    <UserTabs>
      <Content>
        <FormField label="Add User" id="add-user">
          <input id="add-user" type="email" placeholder="User Email" value={newUser.email} onChange={handleChangeNewUserEmail} />
        </FormField>
        <TeamSelector>
          <BlackSelect options={roles && roles.map((item) => ({ label: item.name, value: item.id }))} value={newUser.role} onChange={handleChangeNewUserRole} />
        </TeamSelector>
      </Content>
      <Button onClick={addUser} style={{ width: '80%', height: '30px', marginLeft: '10%', marginBottom: '2rem' }}>Invite User</Button>
      <UsersList>
        {isLocked ? 
        (<>
          <LockedHeader>
            <h2>Users</h2>
            <TooltipIconButton title="Starter, Professional or Enterprise" ariaLabel="unlock-starter" placement="right" size={34} onClick={() => setIsLocked(false)}>
              <LockOutlined fontSize="medium" />
            </TooltipIconButton>
          </LockedHeader>
          <Box display="flex" alignItems="center" justifyContent="space-between" className="header-box" padding="7px">
            <div className="name">USERNAME</div>
            <div className="status">STATUS</div>
            <div className="team">TEAM</div>
            <div className="role">ROLE</div>
            <div className="actions">
              {users.length > 0 ? 
              (<TooltipIconButton title="Delete Team" ariaLabel="delete-team" placement="right" size={24}>
                <DeleteOutline fontSize="small" />
              </TooltipIconButton>) 
              : 
              null}
            </div>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="space-between" className="user-item disabled" padding="7px">
            <div className="name"></div>
            <div className="status">None</div>
            <div className="team">None</div>
            <div className="role">None</div>
            <div className="actions custom-checkbox">
              <input type="checkbox" id="custom-checkbox" disabled />
              <label htmlFor="custom-checkbox" />
            </div>
          </Box>
        </>)
        : 
        (<>
          <h2>Users</h2>
          <Box display="flex" alignItems="center" justifyContent="space-between" className="header-box" padding="7px">
            <div style={{ "width": "8px" }}></div>
            <div className="name">EMAIL</div>
            <div className="team">TEAM</div>
            <div className="actions">
              {users && users.length > 0 ? 
              (<TooltipIconButton title="Delete Users" ariaLabel="delete-team" placement="right" size={24} onClick={deleteUsers}>
                <DeleteOutline fontSize="small" />
              </TooltipIconButton>) 
              : 
              null}
            </div>
          </Box>
          {users && users.map((user, index) => (
            <Box display="flex" alignItems="center" justifyContent="space-between" className="user-item" padding="7px" key={index}>
              <svg viewBox="0 0 10 10" height="8" width="8" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="5" fill="#73BE73" />
              </svg>
              <div className="name">{user.email}</div>
              <div className="team">
                <BlackSelect options={teams.map((item) => ({ label: item.name, value: item.id }))} value={user.team ? user.team.id : null} onChange={(e) => handleChangeUserTeam(e, user, index)} />
              </div>
              <div className="actions custom-checkbox">
                <input type="checkbox" id={`checkbox-` + index} checked={selectedUserIDs.includes(user.user_id)} onChange={() => handleChangeUser(user.user_id)} />
                <label htmlFor={`checkbox-` + index} />
              </div>
            </Box>
          ))}
        </>)}
      </UsersList>
    </UserTabs>
  );
};

export default UsersContent;